import { sleep } from "@/lib/utils";

import type { Api, GeoCountry, GeoCurrency } from "../types";

// Mutable in-memory geo config — the offline mirror of the gateway's
// `geo.countries` / `geo.currencies` settings rows. Edits from the Geo Settings
// page persist for the session. The admin surface returns the full list incl.
// disabled markets (the public storefront filters to enabled).
let countries: GeoCountry[] = [
	{
		code: "RU",
		name: "Россия",
		currency: "RUB",
		cities: [
			"Москва",
			"Санкт-Петербург",
			"Новосибирск",
			"Екатеринбург",
			"Казань",
			"Нижний Новгород",
			"Краснодар",
			"Сочи",
		],
		enabled: true,
	},
	{ code: "AM", name: "Армения", currency: "AMD", cities: ["Ереван", "Гюмри", "Ванадзор", "Вагаршапат", "Раздан"], enabled: true },
	{ code: "BY", name: "Беларусь", currency: "BYN", cities: ["Минск", "Гомель", "Витебск", "Брест", "Гродно"], enabled: true },
	{ code: "KZ", name: "Казахстан", currency: "KZT", cities: ["Алматы", "Астана", "Шымкент", "Караганда", "Актобе"], enabled: true },
	{ code: "GE", name: "Грузия", currency: "GEL", cities: ["Тбилиси", "Батуми", "Кутаиси", "Рустави"], enabled: true },
];

let currencies: GeoCurrency[] = [
	{ code: "RUB", symbol: "₽", name: "Российский рубль", rate: 1, symbolBefore: false },
	{ code: "AMD", symbol: "֏", name: "Армянский драм", rate: 4.3, symbolBefore: false },
	{ code: "BYN", symbol: "Br", name: "Белорусский рубль", rate: 0.036, symbolBefore: false },
	{ code: "KZT", symbol: "₸", name: "Казахстанский тенге", rate: 5.6, symbolBefore: false },
	{ code: "GEL", symbol: "₾", name: "Грузинский лари", rate: 0.029, symbolBefore: false },
	{ code: "USD", symbol: "$", name: "Доллар США", rate: 0.011, symbolBefore: true },
	{ code: "EUR", symbol: "€", name: "Евро", rate: 0.0098, symbolBefore: true },
];

export const geo: Api["geo"] = {
	async listCountries() {
		await sleep(120);
		return countries.map((c) => ({ ...c, cities: [...c.cities] }));
	},
	async updateCountries(next) {
		await sleep(200);
		countries = next.map((c) => ({ ...c, cities: [...c.cities] }));
		return countries.map((c) => ({ ...c, cities: [...c.cities] }));
	},
	async listCurrencies() {
		await sleep(120);
		return currencies.map((c) => ({ ...c }));
	},
	async updateCurrencies(next) {
		await sleep(200);
		currencies = next.map((c) => ({ ...c }));
		return currencies.map((c) => ({ ...c }));
	},
};
